<template>
    <div id="contactThree">
        <div id="workTitle" class="contNavTitle">
            <div>招聘启事</div>
        </div>
        <!-- 职位列表 -->
        <div id="workWrapper">
            <span class="address">天津</span>
            <ul>
                <li v-for="(item,key) in workCont" :key="key" :class="{activeBox:activeBox == key}">
                    <div>
                        <div class="workLeft">
                            <p>{{item.name}}</p>
                            <div class="askBox">
                                <span v-for="(as,key) in item.ask" :key="key">{{as}}<i></i></span>
                            </div>
                            <div class="welfareBox">
                                <span v-for="(wel,key) in item.welfare" :key="key">{{wel}}</span>
                            </div>
                        </div>
                        <div class="workRight">
                            <div>
                                <span>{{item.state}}</span>
                            </div>  
                            <button @click="jobMessage(key)">职位详情</button>
                        </div>
                    </div>
                    <div class="workDetails">
                        <div class="detailsTitle"><span>职位描述</span><div></div></div>
                        <div>
                            <p>岗位职责:</p>
                            <p v-for="(details,k) in item.details[0]" :key = k*6+10>{{k+1}}.{{details}}</p>
                            <p>岗位要求:</p>
                            <p v-for="(details,j) in item.details[1]" :key = j/6-10>{{j+1}}.{{details}}</p>
                            <span class="details_phone">联系电话: 022-58951598</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {work_data} from '@/assets/js/work.js'
// 引入data.js 文件
const workList = {
    work_data
}

export default {
    name: 'Screen5',
    data(){
        return{
            workCont:[],
            activeBox: 100 //活跃的职位详情
        }
    },
    methods:{
        jobMessage(i){
            if(this.activeBox == i){
                this.activeBox = 100
            }else{
                this.activeBox = i
            }
        }
    },
    mounted(){
        this.workCont = workList.work_data
    }
}
</script>

<style scoped>
    #contactThree{
        background: #f4f4f6;
    }
    #workWrapper{
        width: 1090px;
        margin: 0 auto;
        padding: 20px 15px;
        background: #fff;
        font-size: 18px;
    }
    #workWrapper>ul>li{
        padding: 25px 20px 20px;
        background: #f8f9fd;
        margin-bottom: 20px;
        overflow: hidden;
        cursor: default;
        animation:mydefault .5s 1 forwards; 
        -moz-animation:mydefault .5s forwards; 
        -webkit-animation:mydefault .5s 1 forwards;
        -o-animation:mydefault .5s 1 forwards;
    }
    #workWrapper>ul>li>div:first-child{
        overflow: hidden;
        padding-bottom: 2px
    }
    .workLeft{
        max-width: 680px;
        float: left;
    }
    .workLeft>p{
        font-size: 16px;
    }
    .workRight{
        height: 75px;
        width: 115px;
        font-size: 14px;
        float: right;
        display: flex;  /*定位（写在父元素中）*/
        align-items:Center; 
        color: #878986;
    }
    .workRight>div{
        width: 100%;
    }
    .workRight>div>span{
        float: right;
    }
    .workRight>button{
        display: none;
        width: 100%;
        line-height: 40px;
        border-radius: 5px;
        border: 0;
        background: #2d89f6;
        color: #fff;
        cursor: pointer;
    }
    .askBox{
        margin: 10px 0;
    }
    .askBox>span{
        display: inline-block;
        color: #878986;
        position: relative;
    }
    .askBox>span>i{
        display: inline-block;
        font-style:normal;
        width: 1px;
        height: 13px;
        background: #878986;
        margin: 5px 10px 0 10px;
    }
    .askBox>span:last-child>i{
        width: 0;
    }
    .welfareBox>span{
        border: 1px solid #dadbdf;
        color: #9492a7;
        font-size: 12px;
        padding: 2px 8px;
        margin-right: 10px;
        border-radius: 3px;
    }

    #workWrapper>ul>li:hover{
        animation:myActivit .5s 1 forwards; 
        -moz-animation:myActivit .5s forwards; 
        -webkit-animation:myActivit .5s 1 forwards;
        -o-animation:myActivit .5s 1 forwards;
    }
    #workWrapper>ul>li:hover .workRight>div{
        display:none;
    }
    #workWrapper>ul>li:hover .workRight>button{
        display: block;
        animation:myShow .5s 1 forwards; 
        -moz-animation:myShow .5s forwards; 
        -webkit-animation:myShow .5s 1 forwards;
        -o-animation:myShow .5s 1 forwards;
    }
    .address{
      border: 1px solid #4da2fc;
      color: #4da2fc;
      display: inline-block;
      width: 50px;
      text-align: center;
      border-radius: 2px;
    }
    .address:hover{
      background-color: #4da2fc;
      color: #fff;
      cursor:pointer;
    }
    @keyframes myActivit {
        0%{
            background: #f8f9fd;
            box-shadow: 0px 0px 0px 0px #efefef;
        }
        100%{
            background: #fff;
            box-shadow: 0px 2px 5px 1px #efefef;
        }
    }
    @keyframes mydefault {
        0%{
            background: #fff;
            box-shadow: 0px 2px 5px 1px #efefef;
        }
        100%{
            background: #f8f9fd;
            box-shadow: 0px 0px 0px 0px #efefef;
        }
    }
    @keyframes myShow {
        0%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }

    .detailsTitle{
        overflow: hidden;
        line-height: 40px;
        position: relative;
    }
    .detailsTitle>span{
        font-size: 15px;
        font-weight: bold;
        float: left;
    }
    .details_phone{
      border: none;
      color: #69a8f7;
      float: right;
    }
    .detailsTitle>div{
        height: 1px;
        width: 100%;
        background: #ddd;
        position: absolute;
        top: 20px;
        margin-left: 65px;
    }
    .workDetails>div>p{
        line-height: 30px;
    }
    .workDetails{
        display: none;
    }
    .activeBox>.workDetails{
        display: block;
        overflow: hidden;
        animation:myShow .5s 1 forwards; 
        -moz-animation:myShow .5s forwards; 
        -webkit-animation:myShow .5s 1 forwards;
        -o-animation:myShow .5s 1 forwards;
    }
</style>
